import script from "./QuotasView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotasView.vue?vue&type=script&setup=true&lang=js"

import "./QuotasView.vue?vue&type=style&index=0&id=73bb1a34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73bb1a34"]])

export default __exports__